const _ = require('lodash');
const moment = require('moment-timezone');

module.exports = {
  isNumber(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      evt.preventDefault();
    } else {
      return true;
    }
  },

  toQueryString(query) {
    let result = '';
    Object.keys(query).map((q, i) => {
      if (query[q]) {
        result += `${i === 0 ? '?' : '&'}${q}=${query[q]}`;
      }
    });

    return result;
  },
  getFirstError(ex) {
    const errors = this.getErrors(ex) || [];
    if (errors.length) {
      return errors[0].message;
    } else {
      console.error(ex);
      return 'Erro imprevisto';
    }
  },
  getErrors(exception) {
    if (exception && _.isArray(exception.errors)) {
      return exception.errors;
    } else if (exception && exception.message) {
      return [{ message: exception.message, defaultError: true }];
    }
  },
  hasError: function(errors, property) {
    if (
      errors &&
      errors.length &&
      errors.map(e => e.property).indexOf(property) >= 0
    ) {
      return true;
    } else {
      return false;
    }
  },
  getError: function(errors, property) {
    if (this.hasError(errors, property)) {
      return _.find(errors, e => e.property === property).message;
    } else {
      return 'Error';
    }
  },
  errorClass: function(errors, property) {
    if (this.hasError(errors, property)) {
      return 'is-invalid';
    } else {
      return '';
    }
  },
  getDefaultError: function(errors) {
    if (errors && errors.length) {
      const _default = _.find(errors, e => e.defaultError);
      return _default ? _default.message : '';
    } else {
      return '';
    }
  },
  getStartAndEndOfPeriod: function(format) {
    const startOfWeek = moment()
      .startOf(format)
      .format('D');
    const endOfWeek = moment()
      .endOf(format)
      .format('D');

    return {
      start: startOfWeek,
      end: endOfWeek,
      text: `${startOfWeek} - ${endOfWeek}`,
    };
  },
  getSmallText: function(text) {
    let result = '';

    if (text) {
      const parts = text.split(',');
      result = parts[0];
      if (parts.length > 1) {
        result += ' ...';
      }
    }

    return result;
  },
  getTooltipList: function(text) {
    let result = '';
    if (text) {
      result = text.replace(/,/g, '\n');
    }

    return result;
  },
  copy(value, id) {
    const input = document.getElementById(id);
    input.value = value;
    input.style.display = 'block';

    const isiOSDevice = navigator.userAgent.match(/ipad|iphone/i);

    if (isiOSDevice) {
      const editable = input.contentEditable;
      const readOnly = input.readOnly;

      input.contentEditable = true;
      input.readOnly = false;

      const range = document.createRange();
      range.selectNodeContents(input);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      input.setSelectionRange(0, 999999);
      input.contentEditable = editable;
      input.readOnly = readOnly;
    } else {
      input.select();
    }

    document.execCommand('copy');

    input.style.display = 'none';
    input.value = '';
  },
};
